import { Injectable } from '@angular/core';
import { AllowedCountryList } from "@shared/constants/allowed-countries";
import { filter, map } from "rxjs/operators";
import { Phone } from "@shared/models/phone";
import { Store } from "@ngrx/store";
import { CountryState } from "@shared/store/country-store/country.state";
import { Observable } from "rxjs";
import { Country } from "@shared/models/country";
import * as fromSelector from "@shared/store/country-store/counrty.selector";

@Injectable({
  providedIn: 'root'
})
export class PhoneNumberService {

  constructor(private store: Store<CountryState>) { }

  splitPhoneNumberAndCountryCode(phone: string): Observable<Phone> {
   return this.getPhonePrefixList().pipe(
      map((phonePrefixList) => {
        if(phone[0] === '+'){
          if(phonePrefixList) {
            for(const phonePrefix of phonePrefixList) {
              if(phone.startsWith(phonePrefix)){
                return { phonePrefix, phoneNumber: phone.substring(phonePrefix.length) };
              }
            }
            return { phonePrefix: null, phoneNumber: phone };
          }
          return { phonePrefix: null, phoneNumber: phone };
        }
        else {
          return { phonePrefix: null, phoneNumber: phone };
        }
      })
    )
  }

  private getPhonePrefixList(): Observable<string[]> {
    return this.getCountriesByIds(AllowedCountryList).pipe(
      filter(countries => countries !== undefined),
      map((countries) => countries.map(country => country.phonePrefix))
    )
  }

  private getCountriesByIds(ids: string[]): Observable<Country[]> {
    return this.store.select(fromSelector.getCountriesById(ids));
  }
}
